import { TableCellBackgroundColor as Base } from "@corca/tiptap";

import type { Color } from "@corca/data";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    tableCellBackground: {
      setCellBackgroundColor: (color: Color) => ReturnType;
    };
  }
}

export const TableCellBackgroundColor = Base.extend({
  addCommands() {
    return {
      setCellBackgroundColor:
        (backgroundColor) =>
        ({ commands }) => {
          return this.options.types
            .map((type) => commands.updateAttributes(type, { backgroundColor }))
            .every((response) => response);
        },
    };
  },
});
